import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const getErrorMessage = (err) => {
  const serverMessage =
    err?.response?.data?.error?.response?.message ??
    err?.response?.data?.error?.message ?? err?.response?.data?.message;

  if (Array.isArray(serverMessage)) {
    return serverMessage.filter(Boolean).join('\n');
  }

  if (typeof serverMessage === 'string' && serverMessage.trim()) {
    return serverMessage;
  }

  return null;
};

class Api {
  constructor(baseURL) {
    this.adapter = axios.create({
      baseURL,
    });
  }

  request = async ({
    url,
    method = 'get',
    payload,
    headers = {},
    auth = true,
  }) => {
    const request = {
      url: url,
      method,
      data: payload,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
    };

    if (auth) {
      try {
        const token = (await fetchAuthSession()).tokens?.accessToken?.toString();

        if (!token) {
          const noCurrentUserError = new Error('No current user');
          noCurrentUserError.code = 'NotAuthorizedException';
          return Promise.reject(noCurrentUserError);
        }

        request.headers.authorization = `Bearer ${token}`;
      } catch (err) {
        return Promise.reject(err);
      }
    }

    try {
      const response = await this.adapter.request(request);
      return Promise.resolve(response.data);
    } catch (err) {
      if (err.message === 'Network Error') {
        try {
          const response = await this.adapter.request(request);
          return Promise.resolve(response.data);
        } catch (err) {
          const errorMessage = getErrorMessage(err);
          if (err.message === 'Network Error') {
            err.message = 'Error - Try reloading the page';
          } else if (errorMessage) {
            err.message = errorMessage;
          }
          return Promise.reject(err);
        }
      } else {
        const errorMessage = getErrorMessage(err);
        if (errorMessage) {
          err.message = errorMessage;
        }
        return Promise.reject(err);
      }
    }
  };
}

export default new Api(process.env.REACT_APP_API_BASE_URL);
